import React, { useEffect } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import {useForm, Yup} from '../forms/form'
import { useTranslation } from 'react-i18next';
import { FormGroup, Select, Icon } from '../components';
import {
  useGetMonitoredDeviceQuery,
  useGetMonitoredDeviceUsersQuery,
  useDeleteMonitoredDeviceMutation,
  useUpdateMonitoredDeviceMutation
} from '../../api/deviceApiSlice';

const MonitoredDeviceFormModal = ({show, setShow, sptId}) => {
  const { t } = useTranslation();
  const handleClose = () => setShow(false);
  const {
    data: monitoredDevice={ description: "", user_id: ""}
  } = useGetMonitoredDeviceQuery(sptId)
  const {
    data: users=[]
  } = useGetMonitoredDeviceUsersQuery()
  const [updateMonitored] = useUpdateMonitoredDeviceMutation()
  const [deleteMonitored] = useDeleteMonitoredDeviceMutation()
  const initialValues = monitoredDevice;
  const validationSchema = Yup.object().shape({
    description: Yup.string().required(),
    user_id: Yup.number()
  });
  const {
    formData,
    setFormData,
    getInputProps,
    formProps,
    submitButtonProps
  } = useForm({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: () => {
      updateMonitored({...formData, sptId: sptId}).then(response => {
        setShow(false);
      })
    },
  });
  const deleteAction = ()=>{
    deleteMonitored(sptId).then(response => {
      setShow(false);
    })
  }

  useEffect(() => {
    setFormData(monitoredDevice)
  }, [JSON.stringify(monitoredDevice)])

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("monitoredDevice.editTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form {...formProps}>
            <FormGroup
            label={t("monitoredDevice.description")}
            input="textarea"
            {...getInputProps("description")}/>
            <FormGroup label={t("monitoredDevice.user")}
            {...getInputProps("user_id")}>
              <Select isClearable={false} >
                { users.map((u) => (
                  <Option key={u.id} value={u.id}>{u.full_name}</Option>
                )) }
              </Select>
            </FormGroup>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={deleteAction}>
            <Icon icon='trash' text={t("delete")} />
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            <Icon icon='cancel' text={t("cancel")} />
          </Button>
          <Button variant="primary" {...submitButtonProps}>
            <Icon icon='save' text={t("save")} />
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default MonitoredDeviceFormModal